import { defineMessages } from 'react-intl';

export default defineMessages({
  todayLabel: {
    id: 'app.modules.Booking.todayLabel',
    defaultMessage: 'Today',
  },
  allowDurationChangeLabel: {
    id: 'app.modules.Booking.labels.allowDurationChangeLabel',
    defaultMessage: 'Allow duration change upon booking',
  },
  applyChangesFutureEventsLabel: {
    id: 'app.modules.Booking.labels.applyChangesFutureEventsLabel',
    defaultMessage: 'Apply changes to future events',
  },
  notifyParticipantsLabel: {
    id: 'app.modules.Booking.labels.notifyParticipantsLabel',
    defaultMessage: 'Notify participants via:',
  },
  remindParticipantsLabel: {
    id: 'app.modules.Booking.labels.remindParticipantsLabel',
    defaultMessage: 'Remind participants via:',
  },
  preventJoiningLabel: {
    id: 'app.modules.Booking.labels.preventJoiningLabel',
    defaultMessage: 'Prevent joining after',
  },
  preventCancellingLabel: {
    id: 'app.modules.Booking.labels.preventCancellingLabel',
    defaultMessage: 'Prevent cancelling after',
  },
  preventEditingLabel: {
    id: 'app.modules.Booking.labels.preventEditingLabel',
    defaultMessage: 'Prevent editing after',
  },
  noParticipantsAddedLabel: {
    id: 'app.modules.Booking.labels.noParticipantsAddedLabel',
    defaultMessage: 'No participants added yet.',
  },
  availableSpotsLabel: {
    id: 'app.modules.Booking.labels.availableSpotsLabel',
    defaultMessage: '{restSpots} of {spots} spots available to join',
  },
  noAvailableSpotsLabel: {
    id: 'app.modules.Booking.labels.noAvailableSpotsLabel',
    defaultMessage: 'No available spots',
  },
  unlimitedNumberLabel: {
    id: 'app.modules.Booking.labels.unlimitedNumberLabel',
    defaultMessage: 'Unlimited number can join',
  },
  limitClassSpotsLabel: {
    id: 'app.modules.Booking.labels.limitClassSpotsLabel',
    defaultMessage: 'Limit class spots',
  },
  allowSelfBooking: {
    id: 'app.modules.Booking.labels.allowSelfBooking',
    defaultMessage: 'Allow self-booking',
  },
  // buttons
  eventBtn: {
    id: 'app.modules.Booking.eventBtn',
    defaultMessage: 'Event',
  },
  clearAllBtn: {
    id: 'app.modules.Booking.clearAllBtn',
    defaultMessage: 'Clear',
  },
  cancelEventBtn: {
    id: 'app.modules.Booking.cancelEventBtn',
    defaultMessage: 'Cancel Event',
  },
  cancelParticipation: {
    id: 'app.modules.Booking.cancelParticipation',
    defaultMessage: 'Cancel Participation',
  },
  confirmParticipation: {
    id: 'app.modules.Booking.confirmParticipation',
    defaultMessage: 'Confirm Participation',
  },
  restoreEventBtn: {
    id: 'app.modules.Booking.restoreEventBtn',
    defaultMessage: 'Restore Event',
  },
  modificationHistory: {
    id: 'app.modules.Booking.modificationHistory',
    defaultMessage: 'Modification history',
  },
  booking: {
    id: 'app.modules.Booking.booking',
    defaultMessage: 'Booking',
  },
  calendar: {
    id: 'app.modules.Booking.calendar',
    defaultMessage: 'Calendar',
  },
  resources: {
    id: 'app.modules.Booking.resources',
    defaultMessage: 'Resources',
  },
  tags: {
    id: 'app.modules.Booking.tags',
    defaultMessage: 'Tags',
  },
  share: {
    id: 'app.modules.Booking.share',
    defaultMessage: 'Share',
  },
  newEvent: {
    id: 'app.modules.Booking.newEvent',
    defaultMessage: 'New Event',
  },
  editEvent: {
    id: 'app.modules.Booking.editEvent',
    defaultMessage: 'Edit Event',
  },
  remindParticipants: {
    id: 'app.modules.booking.remindParticipants',
    defaultMessage: 'Remind Participants',
  },
  createAppointment: {
    id: 'app.modules.Booking.createAppointment',
    defaultMessage: 'Create appointment',
  },
  additional: {
    id: 'app.modules.Booking.additional',
    defaultMessage: 'Additional',
  },
  // delete event
  deleteEventTitle: {
    id: 'app.routes.booking.event.delete.title',
    defaultMessage: 'Delete Event',
  },
  deleteEventBtn: {
    id: 'app.routes.booking.event.delete.button',
    defaultMessage: 'Delete Event',
  },
  deleteEventWarning: {
    id: 'app.routes.booking.event.delete.warning',
    defaultMessage: "Note, event can't be restored later.",
  },
  cancelEventWarning: {
    id: 'app.routes.booking.event.cancel.warning',
    defaultMessage: 'Note, event can be restored later.',
  },
  deleteEventOnlyThis: {
    id: 'app.routes.booking.event.delete.onlyThisEvent',
    defaultMessage: 'Delete this event only',
  },
  deleteEventAllFuture: {
    id: 'app.routes.booking.event.delete.allFuture',
    defaultMessage: 'Delete all future recurring events',
  },
  cancelEventOnlyThis: {
    id: 'app.routes.booking.event.cancel.onlyThisEvent',
    defaultMessage: 'Cancel this event only',
  },
  cancelEventAllFuture: {
    id: 'app.routes.booking.event.cancel.allFuture',
    defaultMessage: 'Cancel all future recurring events',
  },
  deleteEventReasonLabel: {
    id: 'app.routes.booking.event.delete.reasonLabel',
    defaultMessage: 'Reason',
  },
  deleteResourceWarning: {
    id: 'app.routes.booking.resource.deleteResourceWarning',
    defaultMessage: 'Do you really want to delete resource - {resourceName}',
  },
  newResource: {
    id: 'app.modules.Booking.newResource',
    defaultMessage: 'New Resource',
  },
  deleteResource: {
    id: 'app.modules.Booking.deleteResource',
    defaultMessage: 'Delete resource?',
  },
  editResource: {
    id: 'app.modules.Booking.editResource',
    defaultMessage: 'Edit Resource',
  },
  approveChangeAllowedParticipantsMsg: {
    id: 'app.modules.booking.event.changeAllowedParticipantsModal.msg',
    defaultMessage:
      'All already added participants which are belong to deleting group will be removed',
  },
  copyParticipantsListMsg: {
    id: 'app.modules.booking.duplicateParticipants.modal.msg',
    defaultMessage: 'Do you need to copy participants list?',
  },
  timezoneIsDifferentMsg: {
    id: 'app.modules.booking.eventForm.clubSection.msg',
    defaultMessage:
      "Your timezone view {timezoneViewOffset} is different from club's timezone {clubZoneOffset}. Event will be created on {eventDate} for selected club.",
  },
  restrictEditEventByTimeSingular: {
    id: 'app.modules.booking.eventForm.restrictEditEventByTimeSingular',
    defaultMessage:
      "You can't edit an event 1 hour before it starts. Participants already confirmed their attendance and redeemed sessions",
  },
  restrictEditEventByTimePlural: {
    id: 'app.modules.booking.eventForm.restrictEditEventByTimePlural',
    defaultMessage:
      "You can't edit an event {hours} hours before it starts. Participants already confirmed their attendance and redeemed sessions",
  },
  restrictJoinEventByTimeSingular: {
    id: 'app.modules.booking.eventForm.restrictJoinEventByTimeSingular',
    defaultMessage: "You can't join an event 1 hour before it starts",
  },
  restrictJoinEventByTimePlural: {
    id: 'app.modules.booking.eventForm.restrictJoinEventByTimePlural',
    defaultMessage: "You can't join an event {hours} hours before it starts",
  },
  restrictCancelEventByTimeSingular: {
    id: 'app.modules.booking.eventForm.restrictCancelEventByTimeSingular',
    defaultMessage:
      "You can't cancel an event 1 hour before it starts. Participants already confirmed their attendance and redeemed sessions",
  },
  restrictCancelEventByTimePlural: {
    id: 'app.modules.booking.eventForm.restrictCancelEventByTimePlural',
    defaultMessage:
      "You can't cancel an event {hours} hours before it starts. Participants already confirmed their attendance and redeemed sessions",
  },
  restrictRestoreEventByTimeSingular: {
    id: 'app.modules.booking.eventForm.restrictRestoreEventByTimeSingular',
    defaultMessage: "You can't restore an event 1 hour before it starts",
  },
  restrictRestoreEventByTimePlural: {
    id: 'app.modules.booking.eventForm.restrictRestoreEventByTimePlural',
    defaultMessage: "You can't restore an event {hours} hours before it starts",
  },
  restrictRedeemEventByTime: {
    id: 'app.modules.booking.eventForm.restrictRedeemEventByTime',
    defaultMessage: "You can't redeem events in future. Only within next 2 hours after now",
  },
  eventIsCanceled: {
    id: 'app.modules.booking.eventForm.eventIsCanceled',
    defaultMessage: 'Event is canceled',
  },
  selfBookingIsNotAllowed: {
    id: 'app.modules.booking.eventForm.selfBookingIsNotAllowed',
    defaultMessage: 'Self booking is not allowed',
  },
  restrictionByAttendeeType: {
    id: 'app.modules.booking.eventForm.restrictionByAttendeeType',
    defaultMessage: 'The event has an attendee type restriction',
  },
  userInEvent: {
    id: 'app.modules.booking.eventForm.userInEvent',
    defaultMessage: 'The user has already joined the event',
  },
  userIsNotInEvent: {
    id: 'app.modules.booking.eventForm.userIsNotInEvent',
    defaultMessage: 'User is not in the event. You should join first',
  },
  userInWaitList: {
    id: 'app.modules.booking.eventForm.userInWaitList',
    defaultMessage: 'The user is on the waiting list',
  },
  limitedSpots: {
    id: 'app.modules.booking.eventForm.limitedSpots',
    defaultMessage: 'Spots for the event are limited',
  },
  confirmRestrictionByStatus: {
    id: 'app.modules.booking.eventForm.confirmRestrictionByStatus',
    defaultMessage: "Current participation status ({status}) doesn't allow to confirm",
  },
  cancelRestrictionByStatus: {
    id: 'app.modules.booking.eventForm.cancelRestrictionByStatus',
    defaultMessage: "Current participation status ({status}) doesn't allow to cancel",
  },
  eventIsRedeemed: {
    id: 'app.modules.booking.eventForm.eventIsRedeemed',
    defaultMessage: 'Event is already redeemed',
  },
  eventHasNoScheduledService: {
    id: 'app.modules.booking.eventForm.eventHasNoScheduledService',
    defaultMessage: 'Event has no scheduled service',
  },
  approveChangeClubMsg: {
    id: 'app.modules.booking.event.approveChangeClubMsg.msg',
    defaultMessage: 'All already added resources which are belong to club will be removed',
  },
  // titles
  appointmentNewMemberTourTitle: {
    id: 'app.modules.Booking.appointmentNewMemberTourTitle',
    defaultMessage: 'Tour ({name})',
  },
  resourcesPageTitle: {
    id: 'app.routes.booking.resources.pageTitle',
    defaultMessage: 'Resources',
  },
  approveChangeAllowedParticipantsTitle: {
    id: 'app.routes.booking.resources.changeAllowedParticipants',
    defaultMessage: 'Change allowed participants',
  },
  duplicateParticipantsModalTitle: {
    id: 'app.modules.booking.duplicateParticipants.modal.title',
    defaultMessage: 'Duplicate Event',
  },
  remindParticipantsModalTitle: {
    id: 'app.modules.booking.remindParticipants.modal.title',
    defaultMessage: 'Remind Participants',
  },
  changeClubTitle: {
    id: 'app.routes.booking.resources.changeClub',
    defaultMessage: 'Change club',
  },
  // labels
  eventEditChangeTypeLabel: {
    id: 'app.modules.booking.eventDetails.modal.eventEditChangeType.label',
    defaultMessage: 'Edited event',
  },
  eventCreateChangeTypeLabel: {
    id: 'app.modules.booking.eventDetails.modal.eventCreateChangeType.label',
    defaultMessage: 'Created event',
  },
  // appointment reminder types
  appointmentReminderDays: {
    id: 'app.modules.Booking.appointmentReminder.days',
    defaultMessage: 'Days',
  },
  appointmentReminderWeeks: {
    id: 'app.modules.Booking.appointmentReminder.weeks',
    defaultMessage: 'Weeks',
  },
  appointmentReminderMonths: {
    id: 'app.modules.Booking.appointmentReminder.months',
    defaultMessage: 'Months',
  },
  appointmentReminderYears: {
    id: 'app.modules.Booking.appointmentReminder.years',
    defaultMessage: 'Years',
  },
  // repeat frequencies
  repeatFrequencyDaily: {
    id: 'app.modules.Booking.repeatFrequency.daily',
    defaultMessage: 'Daily',
  },
  repeatFrequencyWeekly: {
    id: 'app.modules.Booking.repeatFrequency.weekly',
    defaultMessage: 'Weekly',
  },
  repeatFrequencyMonthly: {
    id: 'app.modules.Booking.repeatFrequency.monthly',
    defaultMessage: 'Monthly',
  },
  repeatFrequencySemiAnnually: {
    id: 'app.modules.Booking.repeatFrequency.semiAnnually',
    defaultMessage: 'Semi-annually',
  },
  repeatFrequencyAnnually: {
    id: 'app.modules.Booking.repeatFrequency.annually',
    defaultMessage: 'Annually',
  },
  // repeat ends
  repeatEndForever: {
    id: 'app.modules.Booking.repeatEnd.forever',
    defaultMessage: 'Repeat forever',
  },
  repeatEndTimes: {
    id: 'app.modules.Booking.repeatEnd.times',
    defaultMessage: 'Repeat N times',
  },
  repeatEndOnDate: {
    id: 'app.modules.Booking.repeatEnd.onDate',
    defaultMessage: 'On date',
  },
  // attendee types
  attendeeTypeMember: {
    id: 'app.modules.Booking.attendeeType.attendeeTypeMember',
    defaultMessage: 'Member',
  },
  attendeeTypeProspect: {
    id: 'app.modules.Booking.attendeeType.attendeeTypeProspect',
    defaultMessage: 'Prospect',
  },
  attendeeTypeEmployee: {
    id: 'app.modules.Booking.attendeeType.attendeeTypeEmployee',
    defaultMessage: 'Employee',
  },
  // overbooking types
  overbookingTypeNotAllowed: {
    id: 'app.modules.Booking.overbookingType.overbookingTypeNotAllowed',
    defaultMessage: "Don't allow overbooking",
  },
  overbookingTypeWaitlist: {
    id: 'app.modules.Booking.overbookingType.overbookingTypeWaitlist',
    defaultMessage: 'Waitlist',
  },
  overbookingTypeDuplicateEvent: {
    id: 'app.modules.Booking.overbookingType.overbookingTypeDuplicateEvent',
    defaultMessage: 'Duplicate event for extra participants',
  },
  // edit recurring event
  editRecurringModalTitle: {
    id: 'app.modules.booking.editRecurring.modal.title',
    defaultMessage: 'Edit recurring event',
  },
  editRecurringThisEventOption: {
    id: 'app.modules.booking.editRecurring.options.this',
    defaultMessage: 'This event',
  },
  editRecurringFutureEventOption: {
    id: 'app.modules.booking.editRecurring.options.future',
    defaultMessage: 'This and following events',
  },
  editRecurringAllEventOption: {
    id: 'app.modules.booking.editRecurring.options.all',
    defaultMessage: 'All events',
  },
  joinWaitlist: {
    id: 'app.modules.Booking.joinWaitlist',
    defaultMessage: 'Join Waitlist',
  },
  joinClass: {
    id: 'app.modules.Booking.joinClass',
    defaultMessage: 'Join Class',
  },
  youCanJoinTheWaitlist: {
    id: 'app.modules.Booking.youCanJoinTheWaitlist',
    defaultMessage: 'At the moment, there are no available places. You can join the waitlist.',
  },
  resourceLabelNameLength: {
    id: 'app.modules.booking.resourceLabelNameLength',
    defaultMessage: 'Name must be 32 characters or less',
  },
  confirmed: {
    id: 'app.modules.booking.confirmed',
    defaultMessage: 'confirmed',
  },
  positionInQueue: {
    id: 'app.modules.booking.positionInQueue',
    defaultMessage: 'Position in queue',
  },
  participantsLabel: {
    id: 'app.modules.Booking.labels.participantsLabel',
    defaultMessage: 'participants',
  },
  pendingLabel: {
    id: 'app.modules.Booking.labels.pendingLabel',
    defaultMessage: 'pending',
  },
  canceledLabel: {
    id: 'app.modules.Booking.labels.canceledLabel',
    defaultMessage: 'canceled',
  },
  attendedLabel: {
    id: 'app.modules.Booking.labels.attendedLabel',
    defaultMessage: 'attended',
  },
  noShowLabel: {
    id: 'app.modules.Booking.labels.noShowLabel',
    defaultMessage: 'no show',
  },
  unlimitedSlots: {
    id: 'app.modules.Booking.labels.unlimitedSlots',
    defaultMessage: 'Unlimited slots',
  },
  slotsTaken: {
    id: 'app.modules.Booking.labels.slotsTaken',
    defaultMessage: '{bookedSpots} of {spotAmount} slots taken',
  },
});
